import { ObservableValue } from '../state/ObservableValue'
import { MutableRefObject, useState } from 'react'
import { useObservableEffect } from './useObservableEffect'

export function useObservableRef<T>(observableValue: ObservableValue<T | null>): MutableRefObject<T> | null {
  const [ref, setRef] = useState<MutableRefObject<T> | null>(() =>
    observableValue.value === null ? null : { current: observableValue.value },
  )

  useObservableEffect(observableValue, (current) => {
    if (current === null) {
      setRef(null)
    } else if (ref) {
      ref.current = current
    } else {
      setRef({ current })
    }
  })

  return ref
}
